module.exports = __webpack_public_path__ + "img/wzbj.6be9ad7e.png";